export type Voice = {
  quote: string
  author: string
  source: string
}

/**
 * VOC real (ficha DPS44): frases textuales de blogs y FAQs públicos de
 * acro, con su fuente. NO son reseñas del producto y la página lo aclara.
 */
export const teacherVoices: Voice[] = [
  {
    quote: 'This makes you juggle a lot at once.',
    author: 'On teaching acro to mixed levels',
    source: 'youaligned.com, 2018',
  },
  {
    quote: 'can force you to change things up at the last minute.',
    author: 'On odd numbers and mixed groups',
    source: 'youaligned.com, 2018',
  },
  {
    quote: 'If you don’t know where the flyer will land, you are not spotting.',
    author: 'An acrobatics teacher',
    source: 'Elegant Acro, FAQ',
  },
]

export const moreTeacherVoices: Voice[] = [
  {
    quote: 'I am terrified of being upside down.',
    author: 'A beginner student',
    source: 'Elegant Acro, FAQ',
  },
  {
    quote: 'It can definitely feel daunting to show up at jams, especially when you’re not sure what to work on',
    author: 'An acro practitioner on jams',
    source: 'acrolyssa.wordpress.com, 2025',
  },
  {
    quote: 'Many injuries occur simply because there is confusion about the exit strategy.',
    author: 'An acro community blog',
    source: 'slackrobats.com, 2016',
  },
]
